(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }

  function injectTrustBadges() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.rs-trust-row')) return;

    var atc = document.querySelector('.product-form--atc');
    if (!atc) return;

    var row = document.createElement('div');
    row.className = 'rs-trust-row';
    row.innerHTML =
      '<div class="rs-trust-row__item">' +
        '<span class="rs-trust-row__icon">🚚</span>' +
        '<span class="rs-trust-row__label">送料無料</span>' +
        '5,000円以上' +
      '</div>' +
      '<div class="rs-trust-row__item">' +
        '<span class="rs-trust-row__icon">⚡</span>' +
        '<span class="rs-trust-row__label">即日発送</span>' +
        '平日14時まで' +
      '</div>' +
      '<div class="rs-trust-row__item">' +
        '<span class="rs-trust-row__icon">🛡️</span>' +
        '<span class="rs-trust-row__label">安心保証</span>' +
        '正規輸入品' +
      '</div>';
    atc.parentNode.insertBefore(row, atc.nextSibling);
  }

  function setupStickyBuy() {
    if (!document.body.classList.contains('template-product')) return;
    if (!isMobile()) return;
    if (document.querySelector('.rs-sticky-buy')) return;

    var atcBtn = document.querySelector('.product-form--atc-button');
    if (!atcBtn) return;

    var titleEl = document.querySelector('.product-title');
    var priceEl = document.querySelector('.product-pricing .price--main, .product-block--price .price--main, [data-product-pricing] .price--main');
    var imgEl = document.querySelector('.product-gallery img, .product__media img, [data-product-gallery] img, .product-images img');

    var title = titleEl ? titleEl.textContent.trim() : '';
    var price = priceEl ? priceEl.textContent.trim() : '';
    var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';

    var bar = document.createElement('div');
    bar.className = 'rs-sticky-buy';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      (imgSrc ? '<img class="rs-sticky-buy__thumb" src="' + imgSrc + '" alt="">' : '') +
      '<div class="rs-sticky-buy__info">' +
        (title ? '<p class="rs-sticky-buy__title">' + title.replace(/</g,'&lt;') + '</p>' : '') +
        (price ? '<p class="rs-sticky-buy__price">' + price.replace(/</g,'&lt;') + '</p>' : '') +
      '</div>' +
      '<button type="button" class="rs-sticky-buy__btn">カートに追加</button>';

    document.body.appendChild(bar);

    bar.querySelector('.rs-sticky-buy__btn').addEventListener('click', function (e) {
      e.preventDefault();
      atcBtn.click();
    });

    // Update price live if it changes (variant switch)
    if (priceEl && window.MutationObserver) {
      var priceTarget = bar.querySelector('.rs-sticky-buy__price');
      var mo = new MutationObserver(function () {
        if (priceTarget) priceTarget.textContent = priceEl.textContent.trim();
      });
      mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Show when original ATC is OUT of viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting;
          bar.classList.toggle('is-visible', visible);
          bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      io.observe(atcBtn);
    } else {
      // Fallback: always visible after small scroll
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });
    }
  }

  // ----- Free shipping progress bar (mobile sticky purchase bar) -----
  function setupFreeShipBar() {
    if (!document.body.classList.contains('template-product')) return;
    if (!isMobile()) return;
    var bar = document.querySelector('.rs-sticky-buy');
    if (!bar) return;

    var freeShipMin = parseInt(window.RS_FREE_SHIP_MIN || 5000, 10);

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subtotal = (cart && typeof cart.total_price === 'number') ? cart.total_price / 100 : 0;
        var remaining = freeShipMin - subtotal;
        var msg = document.createElement('div');
        msg.className = 'rs-sticky-buy__shipmsg';
        if (remaining <= 0) {
          msg.innerHTML = '<span>🎉 送料無料 適用中</span>';
          msg.classList.add('is-eligible');
        } else {
          var pct = Math.max(0, Math.min(100, (subtotal / freeShipMin) * 100));
          msg.innerHTML =
            '<span>あと <strong>¥' + Math.ceil(remaining).toLocaleString('ja-JP') + '</strong> で送料無料</span>' +
            '<div class="rs-sticky-buy__shipbar"><i style="width:' + pct + '%"></i></div>';
        }
        bar.insertBefore(msg, bar.firstChild);
      })
      .catch(function () {});
  }

  // ----- Per-unit price calculator -----
  function setupPerUnitPrice() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.rs-per-unit-price')) return;

    var titleEl = document.querySelector('.product-title');
    var priceEl = document.querySelector('.product-pricing .price--main, .product-block--price .price--main, [data-product-pricing] .price--main');
    if (!titleEl || !priceEl) return;

    var title = titleEl.textContent || '';
    // Patterns: "×12", "x12", "12袋", "12本", "12個入"
    var unitMatch = title.match(/(?:×|x|✕|X)\s*(\d+)|(\d+)\s*(?:袋|個|本|包|箱|缶|ピース|pcs?|セット)/i);
    if (!unitMatch) return;
    var count = parseInt(unitMatch[1] || unitMatch[2], 10);
    if (!count || count < 2) return;

    var priceMatch = (priceEl.textContent || '').match(/¥\s*([\d,]+)/);
    if (!priceMatch) return;
    var price = parseInt(priceMatch[1].replace(/,/g, ''), 10);
    if (!price) return;

    var perUnit = Math.round(price / count);
    var unit = '個';
    if (/袋/.test(title)) unit = '袋';
    else if (/本/.test(title)) unit = '本';
    else if (/包/.test(title)) unit = '包';
    else if (/缶/.test(title)) unit = '缶';
    else if (/箱/.test(title)) unit = '箱';

    var hint = document.createElement('div');
    hint.className = 'rs-per-unit-price';
    hint.innerHTML = '👉 1' + unit + 'あたり <strong>¥' + perUnit.toLocaleString('ja-JP') + '</strong>';

    var priceContainer = priceEl.closest('.product-block--price') || priceEl.parentNode;
    if (priceContainer && priceContainer.parentNode) {
      priceContainer.parentNode.insertBefore(hint, priceContainer.nextSibling);
    }
  }

  function setupLpThumbnails() {
    var strips = document.querySelectorAll('[data-rs-lp-strip]');
    strips.forEach(function (strip) {
      var main = strip.parentNode.querySelector('[data-rs-lp-main]');
      if (!main) return;
      strip.querySelectorAll('[data-rs-lp-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (!src) return;
          main.src = src;
          strip.querySelectorAll('[data-rs-lp-thumb]').forEach(function (t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  ready(function () {
    injectTrustBadges();
    setupStickyBuy();
    setupLpThumbnails();
    setupPerUnitPrice();
    setupFreeShipBar();
  });
})();
